import { clamp } from 'lodash-es';

export const getNormalizedRange = (currentMin, currentMax, globalMin, globalMax) => {
  const normalize = val => (val === '' ? '' : clamp(Number(val), globalMin, globalMax));

  const nextMin = normalize(currentMin);
  const nextMax = normalize(currentMax);

  const shouldSwap = nextMin !== '' && nextMax !== '' && nextMin > nextMax;

  const stringNextMax = String(nextMax);
  const stringNextMin = String(nextMin);

  return shouldSwap ? [stringNextMax, stringNextMin] : [stringNextMin, stringNextMax];
};

export const validateBoundaries = (val, globalMin, globalMax) => {
  if (val === '') return val;

  const num = Number(val);
  if (num < globalMin) return String(globalMin);
  if (num > globalMax) return String(globalMax);

  return val;
};
